import styled from "styled-components";

export const CardLabel = styled.div`
  width: 100%;
  font-size: ${(props) => props.theme.scaledFontSizes.medium};
  color: ${(props) => props.theme.colors.textColor.secondary};
`;
